type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};

/**
 * Clock / duration icon (outline). Used in Story Manager rows beside a
 * formatted duration. Defaults to `currentColor` so the parent's `color`
 * controls the stroke.
 */
const ClockIcon = ({
  width = '14',
  height = '14',
  strokeColor = 'currentColor',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={strokeColor}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

export default ClockIcon;
